import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import LoadingModal from '../../components/LoadingModal';
import ErrorList from '../../components/ErrorList';
import { setMediaDevicesEnabled, setModalOpeningCount } from '../../redux/application/actions';
import {
    isMediaDevicesEnabledSelector,
    modalOpeningCountSelector,
    requiresPermissionRequestSelector,
} from '../../redux/application/selector';
import AuthService from '../../services/api/auth';
import Helper from '../../helpers';
import Cookies from 'universal-cookie';

class BankidScreen extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false, errors: [] };
    }

    componentDidMount() {
        const { setStep } = this.props;

        let bankidParams = Helper.getUrlParams();
        setStep('BANKID');
        if (bankidParams && bankidParams.code && bankidParams.state) {
            const cookies = new Cookies();
            cookies.set('token', bankidParams.state, { path: '/' });

            AuthService.getUserProperties().then(response => {
                AuthService.loadConfig(response.fleet_id, response.language).then(d => {
                    window.SET_VULOG_DATA(d);
                    this.setState({
                        loading: false,
                    });
                    this.processAuthResult(bankidParams);
                });
            });
        } else {
            this.redirectToBankId();
        }
        // this is a new session, remove cookie;
    }

    redirectToBankId() {
        this.setState({
            loading: true,
        });
        AuthService.getBankIdWidgetUrl()
            .then(response => {
                //url: response.url
                window.location = response.url;
            })
            .catch(e => {
                this.setState({
                    loading: false,
                });
                console.log(e);
            });
    }

    processAuthResult(rawData) {
        if (rawData && rawData.error) {
            document.location.reload();
            return;
        }

        this.setState({
            loading: true,
        });
        AuthService.processBankidAuth(rawData ? rawData : { code: prompt('code?') })
            .then(() => {
                AuthService.getAccountStatus().then(response => {
                    this.setState({
                        loading: false,
                    });
                    if (response.next === null) {
                        this.props.history.push('/status');
                    } else {
                        this.props.history.push(response.next);
                    }
                });
            })
            .catch(response => {
                this.setState({
                    loading: false,
                });
                if (response && response.data && response.data.message) {
                    this.setState({
                        errors: [response.data.message],
                        loading: false,
                    });
                } else {
                    this.setState({
                        errors: ['DEFAULT_ERROR_MESSAGE'],
                        loading: false,
                    });
                }
                //this.props.alert.error('There was an error');
            });
    }

    render() {
        if (!window.VULOG_CONFIG) {
            return null;
        }
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column justify-content-center full-height">
                    <div>
                        <h3 className="page__title-medium">{window.VULOG_TRANSLATE('BANKID_TITLE')}</h3>
                        <p className={'page__subtitle'}>{window.VULOG_TRANSLATE('BANKID_DESCRIPTION')}</p>
                        {window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}

                        <div className="bankid d-flex flex-column justify-content-center">
                            {this.state.url ? (
                                <iframe
                                    title={'bankid'}
                                    src={this.state.url}
                                    frameBorder={0}
                                    style={{ height: '40vh' }}
                                />
                            ) : null}
                        </div>
                        {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && (
                            <ErrorList errors={this.state.errors} hide={this.state.errors.length === 0} />
                        )}
                    </div>
                    {this.state.errors.length !== 0 && this.state.errors[0] !== 'BANKID_AGE_FAILURE' ? (
                        <div className="d-flex flex-row mt-auto mb-1-5rem">
                            <button className="btn btn-primary btn-block" onClick={() => this.redirectToBankId()}>
                                {window.VULOG_TRANSLATE('Retry')}
                                <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                            </button>
                        </div>
                    ) : null}

                    <LoadingModal loading={this.state.loading} />

                    <button id={'backBtn'} style={{ display: 'none' }} onClick={this.backToStatus} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    isMediaDevicesEnabled: isMediaDevicesEnabledSelector(state),
    modalOpeningCount: modalOpeningCountSelector(state),
    requiresPermissionRequest: requiresPermissionRequestSelector(state),
});

const mapDispatchToProps = dispatch => ({
    onSetMediaDevicesEnabled: bindActionCreators(setMediaDevicesEnabled, dispatch),
    onSetModalOpeningCount: bindActionCreators(setModalOpeningCount, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(BankidScreen));
